import React, { useState, useMemo } from "react";
import { Play } from "lucide-react";
import VideoModal from "./VideoModal";

/**
 * VideoGallery — recibe items agrupados por categoría y renderiza
 * secciones con tarjetas estilo "Experiencias". Al clic, abre modal con Vimeo.
 *
 * groups shape:
 * [
 *   { category: 'ADAPTACIÓN', items: [{ brand, activo, image, video }] },
 *   ...
 * ]
 */
export default function VideoGallery({ groups = [] }) {
  const [current, setCurrent] = useState(null);

  const allGroups = useMemo(() => groups.filter((g) => g.items && g.items.length), [groups]);

  return (
    <div className="space-y-16 md:space-y-20">
      {allGroups.map((g, gi) => (
        <div key={gi}>
          <div className="flex items-end justify-between mb-6 md:mb-8 flex-wrap gap-3">
            <h3 className="font-heading text-3xl md:text-4xl tracking-[0.06em] uppercase text-white">
              {g.category}
            </h3>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
            {g.items.map((it, i) => (
              <button
                key={i}
                type="button"
                onClick={() => setCurrent({ url: it.video, title: `${it.brand} · ${it.activo}` })}
                className="group relative overflow-hidden rounded-2xl border border-white/10 bg-neutral-950 hover:border-[#ff8a3c]/40 text-left transition-colors"
              >
                <div className="relative aspect-video overflow-hidden">
                  <img
                    src={it.image}
                    alt={it.brand}
                    loading="lazy"
                    decoding="async"
                    className="w-full h-full object-cover transition-transform duration-[900ms] group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/25 to-transparent" />
                  {/* Play button */}
                  <div className="absolute inset-0 flex items-center justify-center">
                    <span className="w-14 h-14 md:w-16 md:h-16 rounded-full bg-white/90 group-hover:bg-white text-black flex items-center justify-center shadow-2xl transition-transform group-hover:scale-110">
                      <Play className="w-6 h-6 md:w-7 md:h-7 ml-0.5" fill="currentColor" />
                    </span>
                  </div>
                  {/* Activo badge */}
                  <div className="absolute top-4 left-4 inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-black/70 backdrop-blur border border-white/15">
                    <span className="w-1.5 h-1.5 rounded-full bg-[#ff8a3c]" />
                    <span className="font-mono-caps text-[10px] md:text-xs tracking-[0.15em] text-white/85">{it.activo}</span>
                  </div>
                </div>
                <div className="p-5 md:p-6">
                  <h4 className="font-heading text-xl md:text-2xl tracking-[0.06em] uppercase text-white leading-tight">{it.brand}</h4>
                </div>
              </button>
            ))}
          </div>
        </div>
      ))}

      <VideoModal
        open={!!current}
        onClose={() => setCurrent(null)}
        url={current?.url}
        title={current?.title}
      />
    </div>
  );
}
